// extracted by mini-css-extract-plugin
export default {"checkBox":"PostServiceList_checkBox__R8gEJ","table":"PostServiceList_table__zJgBA"};